export default __webpack_public_path__ + "static/media/azure-vnet.da6b5f43.svg";